<template>
  <!-- Proof Points -->
  <b-carousel
    id="carousel-1"
    :interval="4000"
    controls
    indicators
    img-width="1024"     
  >

    <cq-testimonial
        v-for="(owner,index) in testimonials" 
        :key="index"
        :image="owner.imageLink"
        :name="owner.name"
        :designation="owner.designation"
        :messages="owner.messages"
    >
    </cq-testimonial>

  </b-carousel>

<!-- End Proof Points -->  
</template>

<script>

// import CQButton from '../../components/ui/CQButton.vue'
// import CQPara from '../../components/ui/CQPara.vue'
import CQTestimonial from '../../components/ui/CQTestimonial.vue'

// Import Images


export default {
  name: 'Testimonails',
  props: ['testimonials'],
  components: {
     'cq-testimonial' : CQTestimonial,
    
  },
}
</script>

<style scoped>
#carousel-1 >>> .carousel-background{
  background-image: linear-gradient(var(--secondary-color)45%, #C7C8CA); 
  height: 450px;
}

#carousel-1 >>> .carousel-indicators li{
  display: none;
}

#carousel-1 >>> .carousel-control-prev-icon{
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='grey' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e") !important;
}

#carousel-1 >>> .carousel-control-next-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='grey' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e") !important;
}

#carousel-1 >>> #information{
  display: flex;
  align-items: center;
}

/* #carousel-1 >>> #proof1 p{
  border-left: 10px solid red;
} */

#carousel-1 >>> #proof p{
  font-size: 16px !important;
}

/* Mobile View */
@media only screen and (max-width: 992px){
  #carousel-1 >>> .carousel-background{
    background-image: linear-gradient(var(--secondary-color)45%, #C7C8CA); 
    height: 790px;
  }
}
</style>